module.exports = __webpack_public_path__ + "static/media/2.bbd59a23.png";